import { render, staticRenderFns } from "./EvaluationsInfo.vue?vue&type=template&id=117a1748&scoped=true"
import script from "./EvaluationsInfo.vue?vue&type=script&lang=js"
export * from "./EvaluationsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a1748",
  null
  
)

export default component.exports